var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C16.7333 16 17.3613 15.7391 17.884 15.2174C18.4067 14.6956 18.6676 14.0676 18.6667 13.3334C18.6658 12.5991 18.4049 11.9716 17.884 11.4507C17.3631 10.9298 16.7351 10.6685 16 10.6667C15.2649 10.6649 14.6373 10.9262 14.1173 11.4507C13.5973 11.9751 13.336 12.6027 13.3333 13.3334C13.3307 14.064 13.592 14.692 14.1173 15.2174C14.6427 15.7427 15.2702 16.0036 16 16ZM16 29.3334C12.4222 26.2889 9.75022 23.4614 7.984 20.8507C6.21778 18.24 5.33422 15.8231 5.33334 13.6C5.33334 10.2667 6.40578 7.61113 8.55067 5.63335C10.6956 3.65558 13.1787 2.66669 16 2.66669C18.8213 2.66669 21.3049 3.65558 23.4507 5.63335C25.5964 7.61113 26.6684 10.2667 26.6667 13.6C26.6667 15.8222 25.7836 18.2391 24.0173 20.8507C22.2511 23.4622 19.5787 26.2898 16 29.3334Z",
    fill: "#3B54A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/Location_icon.a531571f3a910ab12c80b758cf142817.svg";
export { ForwardRef as ReactComponent };